import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-service-item"
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('swiper', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "auto": "",
      "loop": "",
      "height": "130px",
      "dots-position": "center",
      "dots-class": "dots-class",
      "aspect-ratio": 300 / 800,
      "interval": 5000
    }
  }, [_vm.bannerList.length === 0 ? _c('swiper-item', {
    staticClass: "banner-list"
  }, [_vm.hasMounted ? _c('img', {
    attrs: {
      "src": require("@/assets/img/banner.png"),
      "width": "100%",
      "height": "100%"
    }
  }) : _vm._e()]) : _vm._l(_vm.bannerList, function (item, index) {
    return _c('swiper-item', {
      key: index,
      staticClass: "banner-list"
    }, [_c('img', {
      attrs: {
        "src": item.img_url,
        "width": "100%",
        "height": "100%"
      }
    })]);
  })], 2)], 1), _c('div', {
    staticClass: "home-list"
  }, [_c('div', {
    staticClass: "smy__header-title"
  }, [_c('div', {
    staticClass: "smy__title"
  }, [_vm._v(i18n.tc("420") + _vm._s(_vm.title) + "）")])]), _c(__unplugin_components_0, {
    ref: "serviceList",
    attrs: {
      "is-px": "",
      "show-image": "",
      "height": _vm.scrollerHight,
      "total": _vm.list.length
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c(__unplugin_components_1, {
      key: item.index,
      attrs: {
        "img-url": item.logo || '/spa_static/editIcon/server-4.png',
        "value": item.id,
        "name": item.name
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$router.push({
            name: 'ServiceDetail',
            query: {
              id: item.id
            }
          });
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), !_vm.codeMap['40019'] ? _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {}, [_vm._v(i18n.tc("421") + _vm._s(item.offer_price))])]) : _vm._e()]);
  }), 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };